<div class="modal-general">
  @if (!resultContent) {
  <div class="col-12" style="align-self: flex-start">
    <app-stepper [totalSteps]="3" [currentStep]="currentStep"></app-stepper>
  </div>
  }
  <div class="container">
    <!-- PASO 1 -->
    @if (currentStep == 1 && !resultContent) {
    <div>
      <form [formGroup]="firstFormGroup">
        <div class="row">
          <div class="col-12">
            <h2>
              Es necesaria la siguiente información:
            </h2>
            <p class="sub-title">
              Ten en cuenta que quedará registrada en la aplicación con el aliado.
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <p class="">Estado/situación laboral</p>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <app-custom-select [listItems]="listIncomeSource" [placeholder]="'Elige tu estado/situación laboral'"
              (selectItemEvent)="setValueIncomeSource($event)" [selectItem]="selectIncomeSource"></app-custom-select>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <p class="">Fecha de nacimiento:</p>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="input-container input-with-icon">
              <input type="text" class="input" name="birthDate" placeholder="DD/MM/AAAA" [matDatepicker]="picker"
                [max]="maxDate" required="required" formControlName="birthDate" (input)="formatBirthDateInput($event)"
                (dateChange)="addEvent('change', $event)" maxlength="10">
              <mat-datepicker-toggle class="date-icon" [for]="picker">
                <mat-icon matDatepickerToggleIcon>
                  <img src="assets/images/modals/calendario1.svg" width="24" height="24" alt="calendario">
                </mat-icon>
              </mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-6 padding-right">
            <p class="">¿Cuál es tu banco?</p>
          </div>
          <div class="col-6 padding-left">
            <p class="">Tipo de cuenta</p>
          </div>
        </div>
        <div class="row">
          <div class="col-6 padding-right">
            <app-custom-select [listItems]="listBanks" [placeholder]="'Elige tu banco'"
              (selectItemEvent)="setValueBank($event)" [selectItem]="selectBank"></app-custom-select>
          </div>
          <div class="col-6 padding-left">
            <app-custom-select [listItems]="listAccountType" [placeholder]="'Tipo de cuenta'"
              (selectItemEvent)="setValueAccountType($event)" [selectItem]="selectAccountType"></app-custom-select>
          </div>
        </div>
        <div class="row">
          <div class="col-6 padding-right">
            <p class="">Número de cuenta</p>
          </div>
          <div class="col-6 padding-left">
            <p class="">Confirma el número</p>
          </div>
        </div>
        <div class="row">
          <div class="input-container col-6 padding-right">
            <input type="text" class="input" placeholder="00" maxlength="21" formControlName="bankAccountNumber">
          </div>
          <div class="input-container col-6 padding-left">
            <input type="text" class="input" placeholder="00" maxlength="21" formControlName="confirmBankAccountNumber">
          </div>
          @if (firstFormGroup.errors?.['fieldsDoNotMatch'] &&
          firstFormGroup.get('bankAccountNumber')?.value && firstFormGroup.get('confirmBankAccountNumber')?.value) {
          <div class="col-12">
            <p class="error">El número de cuenta no coincide</p>
          </div>
          }
        </div>
      </form>
    </div>
    }
    <!-- PASO 2 -->
    @if (currentStep == 2 && !resultContent) {
    <div>
      <div class="row">
        <div class="col-12">
          <form [formGroup]="threeFormGroup">
            <h2>
              Escoge la opción que más se ajuste a tus necesidades:
            </h2>
            <div class="input-container mt-4">
              <p class="">Ingresos mensuales:</p>
              <input type="text" class="input" [value]="valorIncome" placeholder="0000000" maxlength="10" id="ingresos"
                formControlName="income" (input)="onInputChangeIncome($event)">
            </div>
            <div class="mt-4">
              <p class="">Elige el plazo de tu crédito:</p>
              <button class="cta-button-term btn-right" [ngClass]="{'selected': selectedTerm === 14}"
                (click)="setRange(true, 14)">14
                días</button>
              <button class="cta-button-term btn-right" [ngClass]="{'selected': selectedTerm === 30}"
                (click)="setRange(true, 30)">30
                días</button>
              <button class="cta-button-term btn-left" [ngClass]="{'selected': selectedTerm === 3}"
                (click)="setRange(false, 3)">3
                cuotas</button>
            </div>
            <div class="input-container mt-4">
              <p class="">Ingresa el monto que quieres solicitar:</p>
              <input type="text" class="input" [value]="valorAmount" placeholder="Monto" maxlength="10"
                id="montoASolicitar" formControlName="amount" (input)="onInputChangeAmount($event)">
              @if (threeFormGroup.get('term')?.valid) {
              <div class="col-12 min-max-texts">
                <span class="left-range">Min:<span>${{range[0] | number:'1.0-2'}}</span></span>
                <span class="right-range">Max:<span>${{range[1] | number:'1.0-2'}}</span></span>
              </div>
              }
            </div>
          </form>
        </div>
      </div>
    </div>
    }
    <!-- PASO 3 -->
    @if (currentStep == 3 && !resultContent) {
    <div>
      <div class="row">
        <div class="col-12">
          <h2>
            ¡Estamos muy cerca de terminar!
          </h2>
          <p class="sub-title">
            Recuerda que esta información quedará registrada en la aplicación con el aliado.
          </p>
        </div>
      </div>
      <form [formGroup]="secondFormGroup">
        <div class="row">
          <div class="col-12">
            <p class="">Dirección</p>
          </div>
        </div>
        <div class="row">
          <div class="col-6 padding-right">
            <app-custom-select [listItems]="listAddressStreetType" [placeholder]="'Carrera'"
              (selectItemEvent)="setValueAddressStreetType($event)"></app-custom-select>
          </div>
          <div class="input-container col-6 padding-left">
            <input type="text" class="input" placeholder="12 A" maxlength="21" formControlName="addressStreet">
          </div>
        </div>
        <div class="row">
          <div class="col-6 padding-right">
            <input type="text" class="input" placeholder="00" maxlength="21"
              formControlName="addressStreetSecondaryNumber">
          </div>
          <div class="col-6 padding-left">
            <input type="text" class="input" placeholder="00" maxlength="21"
              formControlName="addressStreetComplementNumber">
          </div>
        </div>
        <div class="row margin-top-10px">
          <div class="col-12">
            <p class="">Segundo número de contacto</p>
          </div>
          <div class="col-12">
            <input type="text" class="input" placeholder="3000000000" maxlength="10" id="celular"
              formControlName="alternativePhone">
          </div>
          @if (secondFormGroup.get('alternativePhone')?.errors?.['pattern'] ||
          secondFormGroup.get('alternativePhone')?.errors?.['minlength']) {
          <div class="col-12">
            <p class="error">Fomato telefono no valido</p>
          </div>
          }
        </div>
        <div class="container margin-top-10px">
          <div class="row check-div-info">
            <div class="col-2 d-flex justify-content-center align-items-center p-0">
              <input type="checkbox" formControlName="tyc" aria-label="Checkbox for following text input">
            </div>
            <div class="col-10 info-term-cond">
              <span>He leído y acepto los <span class="font-weight-bold"><ins><a
                      href="https://prestamos.wasticredit.com.co/legal/Contrato_Terminos_Generales_WASTICREDIT_VF_20250710.pdf"
                      target="_blank">TyC</a></ins></span>
                y autorizo el tratamiento de mis
                datos personales.</span>
            </div>
          </div>
        </div>
      </form>
    </div>
    }
  </div>
  @if (resultContent) {
  <div class="container result-page">
    <div class="row">
      <div class="col-12">
        @if (success) {
        <div class="modal-success">
          <h2 class="green">¡Buenas noticias, {{sesion.nameSession}}!</h2>
          <p>Tu <b>{{offer.offerSelected?.card?.productName}}</b> está casi listo para
            ser
            aprobado.</p>
          <p class="text-center">Algunas cosas a tener en cuenta para continuar con tu proceso
            de
            aplicación:</p>
          <p><b class="numeral">1.</b> Buscacrédito hace un pre-filtro de tu perfil
            crediticio,
            sin embargo, la
            <b>aprobación final</b> dependerá de <b>{{offer.offerSelected?.company?.name}}</b>.
          </p>
          <p><b class="numeral">2.</b> El proceso de aplicación se termina en el <b>sitio web
              del
              aliado</b>,
            nosotros te
            redireccionaremos allí.</p>
          <p><b class="numeral">3.</b> <b> Los tiempos</b> de respuesta varían de acuerdo con
            las
            políticas de cada
            entidad..</p>
        </div>
        }
        @if (!success && !refused) {
        <div>
          <h2 class="error">
            ¡Ups! Algo salió mal.
          </h2>
          <p class="sub-title">
            No pudimos procesar tu aplicación para la oferta seleccionada en este momento. Por favor,
            intenta nuevamente más tarde.
          </p>
        </div>
        }
        @if (!success && refused) {
        <div>
          <h2 class="error">
            ¡Lo sentimos!
          </h2>
          <p class="sub-title">
            No fue posible continuar con tu solicitud debido a las políticas crediticias de
            <b>{{offer.offerSelected.company.name}}.</b>
          </p>
          <p class="sub-title">
            Te invitamos a conocer más ofertas disponibles para ti.
          </p>
        </div>
        }
      </div>
    </div>
  </div>
  }
  <!-- Controls Buttons  -->
  <div class="container">
    <div class="row">
      @if (!resultContent) {
      <div class="col-12 margin-top-20px">
        @if (currentStep == 1) {
        <button class="cta-button secondary btn-right" (click)="this.load.closeBcConecta()">Cancelar</button>
        }
        @if (currentStep == 2) {
        <button class="cta-button secondary btn-right" (click)="returnStep()">Regresar</button>
        }
        @if (currentStep == 3) {
        <button class="cta-button secondary btn-right" (click)="returnStep()">Regresar</button>
        }
        @if (currentStep == 1) {
        <button class="cta-button btn-left" [disabled]="firstFormGroup.invalid" (click)="nextStep()">Continuar<i
            class="fa fa-chevron-right" aria-hidden="true"></i></button>
        }
        @if (currentStep == 2) {
        <button class="cta-button btn-left" [disabled]="threeFormGroup.invalid" (click)="nextStep()">Continuar<i
            class="fa fa-chevron-right" aria-hidden="true"></i></button>
        }
        @if (currentStep == 3) {
        <button class="cta-button btn-left" [disabled]="secondFormGroup.invalid" (click)="applyOffer()">Aplicar<i
            class="fa fa-chevron-right" aria-hidden="true"></i></button>
        }
      </div>
      }
    </div>
    @if (resultContent) {
    <div class="row margin-top-10px">
      <div class="col-12 text-center">
        @if (success) {
        <button class="btn-mrkt green" (click)="redirectWasticredit()">Continuar con la aplicación<i
            class="fa fa-chevron-right" aria-hidden="true"></i></button>
        }
        @if (!success && !refused) {
        <button class="cta-button" (click)="load.closeBcConecta()">Entendido<i class="fa fa-chevron-right"
            aria-hidden="true"></i></button>
        }
        @if (!success && refused) {
        <button class="cta-button" (click)="redirectToOffers()">Conocer más
          ofertas<i class="fa fa-chevron-right" aria-hidden="true"></i></button>
        }
      </div>
    </div>
    }
    <div class="row margin-top-12px">
      @if ((!success && !resultContent) || (success && resultContent)) {
      <button type="button" (click)="returnConfirmTelephone()" class="btn-mrkt secondary">
        Actualizar mi número de celular
      </button>
      }
    </div>
  </div>
</div>